<mat-card appearance="outlined">
  <mat-card-content>
    @if (hasProductDependencies) {
      <div class="requirements-header">
        <h2 class="va-component-subtitle">
          {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PRODUCT_REQUIREMENTS.LABEL' | translate }}
        </h2>
        <mat-icon
          [glxyPopover]="productRequirementsPopover"
          (mouseenter)="showProductRequirementsPopover = true"
          (mouseleave)="showProductRequirementsPopover = false"
          inline
          >
          info_outline
        </mat-icon>
        <glxy-popover #productRequirementsPopover [isOpen]="showProductRequirementsPopover">
          <glxy-popover-title>
            {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PRODUCT_REQUIREMENTS.TOOLTIP.TITLE' | translate }}
          </glxy-popover-title>
          @if (marketingType === MarketingType.EndUser) {
            {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PRODUCT_REQUIREMENTS.TOOLTIP.EXTERNAL_DESCRIPTION' | translate }}
          } @else {
            {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PRODUCT_REQUIREMENTS.TOOLTIP.INTERNAL_DESCRIPTION' | translate }}
          }
        </glxy-popover>
      </div>
      <div class="product-requirements">
        <store-required-products-list
          [product]="product"
          [marketingType]="marketingType"
          [personaType]="personaType"
          [partnerId]="partnerId"
          [marketId]="marketId"
        ></store-required-products-list>
      </div>
    }
    <h2 class="va-component-subtitle">
      {{ 'FRONTEND.STORE.AVAILABLE_IN' | translate }}
    </h2>
    <store-supported-countries-v2
      [businessCountryCode]="businessCountryCode"
      [countryCodes]="product.restrictions.country.whitelist"
    ></store-supported-countries-v2>
  </mat-card-content>
</mat-card>
